<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>Rejection Reason</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-form v-model="valid">
                <v-text-field
                    v-model="rejectionReason.reason"
                    hide-details
                    prepend-icon="mdi-label"
                    label="Name"
                    :rules="[rules.required]"
                    required
                />
                <v-row no-gutters class="mt-2">
                    <v-col cols="12">
                        <v-textarea
                            v-model="rejectionReason.description"
                            prepend-icon="mdi-text"
                            label="Description"
                            hide-details
                            rows="2"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                @click="saveReason"
                rounded
                :loading="loading"
                :disabled="!valid"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import { objDiff } from '@/helpers/objDiff.js'

export default {
    name: 'RejectionReasonsForm',
    props: {
        rejectionReason: {
            type: Object,
            default: () => ({}),
        },
        originalRejectionReason: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: () => false,
        },
        reasonSettings: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        loading: false,
        rules: {
            required: v => !!v || 'Required',
        },
        valid: false,
    }),
    computed: {
        reasonDiff() {
            if (!this.createForm) {
                return objDiff(
                    this.originalRejectionReason,
                    this.rejectionReason
                )
            } else {
                return null
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async saveReason() {
            if (this.createForm) {
                await this.create()
            } else {
                await this.update()
            }
        },
        async create() {
            try {
                this.loading = true
                const reason = await API.createRejectionReason({
                    settingId: this.reasonSettings.id,
                    ...this.rejectionReason,
                })
                this.$emit('addReason', reason)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async update() {
            try {
                this.loading = true
                const reason = await API.updateRejectionReason({
                    settingId: this.reasonSettings.id,
                    rejectionReasonId: this.rejectionReason.id,
                    ...this.reasonDiff,
                })
                this.$emit('replaceReason', reason)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>
